import { useState, useEffect } from "react";
import PrintSVG from "../../utils/assets/client/printer.svg";
import ProfileSVG from "../../utils/assets/client/user.svg";
import {
  fetchTicketDetails,
  fetchTicketNotes,
  fetchTicketStatus,
  postTicketNotes,
} from "../../actions/admin/tickets";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import Comments from "../../components/client/Comments";
import { toast } from "react-toastify";

const TicketsDetailsPage = () => {
  const [ticketDetails, setTicketDetails] = useState([]);
  const [statusData, setStatusData] = useState([])
  const [notesData, setNotesData] = useState([]);
  const { id } = useParams();

  useEffect(() => {
    const token = localStorage.getItem("token");
    fetchTicketDetails(token, id).then((res) => {
      setTicketDetails(res.data);
    });
    fetchTicketNotes(token, id).then((res) => {
      setNotesData(res.data);
    });
    fetchTicketStatus(token).then((res) => {
      setStatusData(res.data)
    })


  }, []);
  const handleStatuses = (title) => {
    if (!title) return null;
    return statusData?.find(
      (item) => item.title.toLowerCase() === title.toLowerCase()
    ) || null;
  };

  const handleComments = async (note) => {
    const token = localStorage.getItem("token");

    const data = {
      ticket_id: id,
      note,
    };

    await postTicketNotes(token, data).then((res) => {
      if (res.success == true) {
        toast.success("Note Added Successfully");
        fetchTicketNotes(token, id).then((res) => {
          console.log("note", res);
          setNotesData(res.data);
        });
      } else {
        toast.error("Something went wrong");
      }
    });
  };

  return (
    <div className="bg_color_gray">
      <div className="mx-4 mx-lg-4 mx-md-4 ">
        <div className="row pt-3">
          <h3 className="lg-device_screen">Ticket Details</h3>
          <h3 className="md-device_screen">Ticket #{ticketDetails?.ticket_id}</h3>
        </div>
       
        <div className="row bg-white shadow rounded lg-device_screen">
          <div className="px-5 py-4  d-flex">
            <div className="col-6 d-flex justify-content-start align-items-center">
              
            <div
                className="border bg-white d-flex justify-content-center align-items-center mx-2"
                style={{ borderRadius: "50%", overflow: "hidden", maxWidth: "90px", maxHeight: "90px" }}
              >
                <img
                  className="p-2"
                  src={ProfileSVG}
                  width={85}
                  alt="profile"
                />
              </div>
              <div className="d-flex flex-column mx-3">
                <span className="f-24">
                  {ticketDetails?.lead?.customer?.first_name}{" "}
                  {ticketDetails?.lead?.customer?.last_name}
                </span>
                <span className="">
                  Email: {ticketDetails?.lead?.customer?.email}
                </span>
                <span className="">
                  Mobile : {ticketDetails?.lead?.customer?.phone}
                </span>
                <span className="">
                  Address : {ticketDetails?.lead?.customer?.address}
                </span>
              </div>
            </div>
            <div className="col-6 d-flex justify-content-end text-end align-items-center">
              <div className="d-flex flex-column">
                <span className="f-24">#{ticketDetails?.ticket_id}</span>
                <span className="Other_desc">Created date : 03-10-2024</span>
                <span className="Other_desc">Store Location : Repair Desk</span>
                <button className="btn  bg-black text-white py-2 px-4 mt-3 d-flex justify-content-center align-items-center">
                  {" "}
                  <img
                    src={PrintSVG}
                    width={17}
                    style={{ marginRight: "5px" }}
                    alt="print"
                  />
                  <span className="mx-2">Print</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* sm device  start*/}
        <div className="row bg-white shadow md-device_screen">
          <div className=" py-4 d-flex">
            <div className="col-lg-6 col-md-6 col-xs-12 col-sm-12 d-flex justify-content-center align-items-center">
              <div className="row ">
                <div className="col-12 d-flex flex-column justify-content-center align-items-center">
                  <div
                className="border bg-white d-flex justify-content-center align-items-center mx-2"
                style={{ borderRadius: "50%", overflow: "hidden", maxWidth: "90px", maxHeight: "90px" }}
              >
                <img
                  className="p-2"
                  src={ProfileSVG}
                  width={85}
                  alt="profile"
                />
              </div>
              <span className="f-24 text-center">
                  {ticketDetails?.lead?.customer?.first_name}{" "}
                  {ticketDetails?.lead?.customer?.last_name}
                </span>
                </div>
                <div className="col-12">
                <div className="d-flex flex-column justify-content-center align-items-center text-center mt-2 p-2">
                
                <p className="mb-0">
                  Email: {ticketDetails?.lead?.customer?.email}
                </p>
                <span className="">
                  Mobile : {ticketDetails?.lead?.customer?.phone}
                </span>
                <span className="">
                  Address : {ticketDetails?.lead?.customer?.address}
                </span>
                <span className="Other_desc">Created date : 03-10-2024</span>
                <span className="Other_desc">Store Location : Repair Desk</span>
                <button className="btn w-75  bg-black text-white py-2 px-4 mt-3 d-flex justify-content-center align-items-center">
                  {" "}
                  <img
                    src={PrintSVG}
                    width={17}
                    style={{ marginRight: "5px" }}
                    alt="print"
                  />
                  <span className="mx-2">Print</span>
                </button>
              </div>
                </div>
              </div>
              
            </div>
            {/* <div className="col-lg-6 col-md-6 col-xs-12 col-sm-12 d-flex justify-content-end text-end align-items-center">
              <div className="d-flex flex-column">
                <span className="f-24">#{ticketDetails?.ticket_id}</span>
                <span className="Other_desc">Created date : 03-10-2024</span>
                <span className="Other_desc">Store Location : Repair Desk</span>
                <button className="btn  bg-black text-white py-2 px-4 mt-3 d-flex justify-content-center align-items-center">
                  {" "}
                  <img
                    src={PrintSVG}
                    width={17}
                    style={{ marginRight: "5px" }}
                    alt="print"
                  />
                  <span className="mx-2">Print</span>
                </button>
              </div>
            </div> */}
          </div>
        </div>
        {/* sm device  end*/}

        <div className="my-3">
          <div className="row rounded shadow bg-light overflow-hidden">
            <p className="txt-head bg-black  px-3 text-white p-2 mb-0">Ticket Item (s)</p>
            <table className="table  table-hover">
              <thead>
                <tr>
                  <td className="px-4">Device</td>
                  <td>Estimate ID</td>
                  <td>Device Issue</td>
                  <td>IMEI/Serial</td>
                  <td>Type</td>
                  <td>Estimated Date & Time</td>
                  <td>Price Estimate</td>
                  <td>Tax</td>
                  <td>Status</td>
                  <td>Action</td>
                </tr>
              </thead>
              <tbody>
                {ticketDetails?.lead?.lead_items.length > 0
                  ? ticketDetails.lead.lead_items.map((item) => {
                      return (
                        <tr>
                          <td className="px-4">
                            {item.brand.name} {item.devices[0].title}
                          </td>
                          <td>Estimate ID</td>
                          <td >
                            <div className="d-flex flex-column">
                            {item.defects.map((defect) => {
                              return (
                                <span key={defect.id}>{defect.title}</span>
                              );
                            })}
                            </div>
                           
                          </td>
                          <td>
                            {item.imei_no ? item.imei_no : item.serial_no}
                          </td>
                          <td>{item.delivery_type}</td>
                          <td>
                            {ticketDetails?.repair_time
                              ? ticketDetails?.repair_time
                              : "-"}
                          </td>
                          <td>£ {item.lead_value}</td>
                          <td>£ {item.tax}</td>
                          <td>
                          <span
    className="badge p-2"
    style={{ backgroundColor: handleStatuses(ticketDetails?.status)?.color_code || '#ccc' }} // fallback color
  >
    {ticketDetails?.status}
  </span>
                            </td>
                          <td>Action</td>
                        </tr>
                      );
                    })
                  : ""}
              </tbody>
            </table>
            <div className="card_radius total_card bg-white d-flex flex-column justify-content-center text-end p-3 f-16 txt-secondary">
              <div className="d-flex justify-content-between align-items-center">
                <span>Sub Total :</span>
                <span>$0.00</span>
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <span>Discount :</span>
                <span>$0.00</span>
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <span>GST :</span>
                <span>$0.00</span>
              </div>
              <hr />
              <div className="d-flex justify-content-between align-items-center">
                <span className="text-dark" style={{ fontSize: "20px" }}>
                  Total :{" "}
                </span>
                <span className="text-dark" style={{ fontSize: "20px" }}>
                  $0.00
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="mb-5">
          <Comments
            header={"Ticket History"}
            notesData={notesData}
            submit={handleComments}
          />
        </div>
      </div>
    </div>
  );
};

export default TicketsDetailsPage;
